// Aturan murni untuk layar Audit & Approval.

/**
 * Apakah teks acuan (`ref_id`) berupa NOMOR SERVIS, sehingga boleh dibuat tautan ke tiketnya?
 * Bentuknya OUTLET-yymmdd-XXXX (lihat `genNo`). Acuan lain — id karyawan, nomor batch komisi,
 * kunci setelan — TIDAK boleh jadi tautan: mengkliknya hanya akan memunculkan "tiket tak
 * ditemukan" dan membuat petugas ragu apakah datanya hilang.
 */
export const isNoServis = (ref: string | null | undefined): boolean =>
  /^[A-Z]{2,5}-\d{6}-[A-Z0-9]{4}$/.test((ref ?? '').trim());

/** Umur minimum (hari) sebuah baris audit sebelum boleh dipangkas. */
export const AUDIT_MIN_UMUR_HARI = 90;

/**
 * Batas tanggal terbaru yang boleh dipangkas: hari ini dikurangi masa simpan wajib.
 * Jejak yang masih baru TIDAK boleh dihapus — kalau boleh, orang yang berbuat curang tinggal
 * menghapus jejaknya sendiri di hari yang sama dan seluruh kontrol ini jadi percuma.
 * (Database juga menegakkan batas yang sama; ini agar layarnya tak menawarkan yang mustahil.)
 */
export function batasPangkasAudit(hariIni: Date, minUmurHari = AUDIT_MIN_UMUR_HARI): string {
  const d = new Date(hariIni.getTime() - minUmurHari * 86400000);
  return d.toISOString().slice(0, 10);
}

/** Boleh dipangkas sampai tanggal `sampai`? (dibanding batas aman) */
export const bolehPangkas = (sampai: string, batas: string): boolean =>
  !!sampai && sampai <= batas;
